<template>
  <div class="title">
    <div class="title-left">{{ title }}</div>
    <!-- <div class="title-right" v-if="enTitle" @click="viewMore">更多</div> -->
  </div>
</template>

<script>
export default {
  name: 'CockpitTitle',
  data() {
    return {}
  },
  props: {
    title: {
      type: String
    },
    enTitle: {
      type: String
    }
  },
  methods: {
    viewMore() {
      const data = {
        title: this.title,
        enTitle: this.enTitle,
        show: true
      }
      this.$store.dispatch('cockpit/getDialogInfo', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  color: rgba(255, 255, 255, 100);
  display: flex;
  justify-content: space-between;
  background: url('~@/assets/cockpit/cockpit-title.png') no-repeat center/100%
    auto;
  padding: 0.07rem 0.3rem;
  &-left {
    font-size: 0.2rem;
  }
  &-right {
    opacity: 0.65;
    font-size: 0.18rem;
    cursor: pointer;
  }
}
</style>
